module.exports = __webpack_public_path__ + "images/secret-admirer-0eeeb45ace0e468fa84ae59836bc42f9.png";